import { Grid, Text } from '@mantine/core';
import { ReactNode } from 'react';

interface Props {
  label: string;
  children: ReactNode;
}

export const FormFieldDrawer = ({ label, children }: Props) => {
  return (
    <Grid>
      <Grid.Col span={4}>
        <Text>{label}</Text>
      </Grid.Col>
      <Grid.Col span={7}>{children}</Grid.Col>
    </Grid>
  );
};
